import { useMemo } from "react";
import { BuilderRoutes, createBuilderApi, Link, NavProvider, useNav } from "@delegate/employee-builder/web";
import { Button } from "@/components/ui/button";
import { BrandDots } from "@/components/brand/brand-dots";
import { Credentials } from "./Credentials.tsx";

function Header({ email, onSignedOut }: { email: string; onSignedOut: () => void }) {
  const { path } = useNav();
  const item = (to: string, label: string, active: boolean) => (
    <Link to={to} className={`rounded-md px-3 py-1.5 text-sm transition-colors ${active ? "bg-accent text-accent-foreground" : "text-muted-foreground hover:text-foreground"}`}>
      {label}
    </Link>
  );
  return (
    <header className="border-b">
      <div className="mx-auto flex max-w-6xl flex-wrap items-center justify-between gap-3 px-6 py-3">
        <div className="flex items-center gap-4">
          <Link to="/" className="flex items-center gap-2 font-semibold tracking-tight">
            <BrandDots size="sm" />
            Employee Builder
          </Link>
          <nav className="flex gap-1">
            {item("/", "Employees", path === "/" || path.startsWith("/employees") || path === "/new")}
            {item("/credentials", "Tenant access", path === "/credentials")}
          </nav>
        </div>
        <div className="flex items-center gap-2">
          <span className="text-sm text-muted-foreground">{email}</span>
          <Button
            variant="ghost"
            size="sm"
            onClick={async () => {
              await fetch("/api/auth/logout", { method: "POST" });
              onSignedOut();
            }}
          >
            Sign out
          </Button>
        </div>
      </div>
    </header>
  );
}

function Routes() {
  const { path } = useNav();
  const api = useMemo(() => createBuilderApi("/api/builder"), []);
  if (path === "/credentials") return <Credentials />;
  return <BuilderRoutes api={api} />;
}

export function App({ email, onSignedOut }: { email: string; onSignedOut: () => void }) {
  return (
    <NavProvider base="">
      <div className="min-h-dvh bg-background">
        <Header email={email} onSignedOut={onSignedOut} />
        <main className="mx-auto max-w-6xl px-6 py-8">
          <Routes />
        </main>
      </div>
    </NavProvider>
  );
}
